import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { urlServer } from '../global_constants';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class ProfilService {

  token:any;
  pathApi:string="/v1/profiles";
  urlRequestProfile: string = urlServer.concat(this.pathApi);

  pathProfilApi:string="/v1/profile";
  urlRequestNewProfile: string = urlServer.concat(this.pathProfilApi);

  pathAffectApi:string="/v1/profile/affect";
  urlRequestAffectProfile: string = urlServer.concat(this.pathAffectApi);  
  
  pathEditApi:string="/v1/profile";
  urlRequestUpdateProfile: string = urlServer.concat(this.pathEditApi);

  pathHistoryApi:string="/v1/profile/history/";
  urlRequestHistory: string = urlServer.concat(this.pathHistoryApi);

  constructor(private http:HttpClient) {
    this.newProfilSubject = new Subject();
    this.editProfilSubject = new Subject();
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) {
      this.token = localStorage.getItem("token");
    } else {
      this.token = sessionStorage.getItem("token");
    }
  }

  getCompanyProfiles(): Observable<ServiceResponse> {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.http.get<ServiceResponse>(this.urlRequestProfile,{headers: header});
  }
  newProfilSubject:Subject<any>;

  createProfile(profileData: any){
    this.newProfilSubject = new Subject();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.token);
    this.http.post(this.urlRequestNewProfile, profileData, { headers }).subscribe((response: any) => {
      this.newProfilSubject.next(response);
      this.newProfilSubject.complete();
  },
    error => {
      console.error('There was an error!', error);
    }
  );
  }

  editProfilSubject:Subject<any>;

  updateProfile(profileData: any){
    this.editProfilSubject = new Subject();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.token);
    this.http.patch(this.urlRequestUpdateProfile, profileData, { headers }).subscribe((response: any) => {
      this.editProfilSubject.next(response);
      this.editProfilSubject.complete();
  },
    error => {
      console.error('There was an error!', error);
    }
  );
  }

  affectProfile(profileUuid: string, userUuid: string, ): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.token);
    const body = { profileUuid: profileUuid, userUuid: userUuid };

    return this.http.post(this.urlRequestAffectProfile, body, { headers });
}
getHistory(userUuid : any, forWhat:any): Observable<ServiceResponse> {
  let header: HttpHeaders = new HttpHeaders();
  header = header.set('authorization', "Bearer " + this.token);
  return this.http.get<ServiceResponse>(this.urlRequestHistory+userUuid+forWhat,{headers: header});
}

}
